module.exports = __webpack_public_path__ + "static/14-19755586c6317646d92af73f2bd78b1c.png";